import { TStatusIcon } from '@components/Status/Status.interface';
import { TInquiryStatus } from '@interfaces/inquiries';

const statusMap = {
  [TInquiryStatus.None]: TStatusIcon.Blank,
  [TInquiryStatus.Draft]: TStatusIcon.Purple,
  [TInquiryStatus.Pending]: TStatusIcon.Orange,
  [TInquiryStatus.NeedsInfo]: TStatusIcon.Yellow,
  [TInquiryStatus.Complete]: TStatusIcon.Green,
  [TInquiryStatus.New]: TStatusIcon.Blue,
};

export const getStatusIcon = (value: TInquiryStatus) => statusMap[value];

export const getCustomIcon = (value: TInquiryStatus) => {
  if (value === TInquiryStatus.Draft) return <img src="/images/img-draft.svg" />;
  if (value === TInquiryStatus.NeedsInfo) return <img src="/images/img-needsinfo.svg" />;
};
